/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_UnavailableInputs */

const en_us2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The microphone is not available on this device. Type your message instead.`)
};

const pt_br2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O microfone não está disponível neste aparelho. Digite a mensagem.`)
};

const es_419_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El micrófono no está disponible en este dispositivo. Escribe tu mensaje.`)
};

const pt_pt2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O microfone não está disponível neste dispositivo. Escreve a mensagem.`)
};

const fr_fr2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le micro n'est pas disponible sur cet appareil. Écris ton message.`)
};

const de_de2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Mikrofon ist auf diesem Gerät nicht verfügbar. Tippe deine Nachricht stattdessen.`)
};

const it_it2_coach_mic_unavailable = /** @type {(inputs: Coach_Mic_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il microfono non è disponibile su questo dispositivo. Scrivi il messaggio.`)
};

/**
* | output |
* | --- |
* | "The microphone is not available on this device. Type your message instead." |
*
* @param {Coach_Mic_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_unavailable = /** @type {((inputs?: Coach_Mic_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_unavailable(inputs)
	if (locale === "es-419") return es_419_coach_mic_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_unavailable(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_unavailable(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_unavailable(inputs)
	return en_us2_coach_mic_unavailable(inputs)
});
export { coach_mic_unavailable as "coach-mic.unavailable" }